import React from "react";
import DocCenter from "../components/DocCenter";

function DocCenterPage() {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <DocCenter />
      </div>
    </div>
  );
}

export default DocCenterPage;
